import { render, staticRenderFns } from "./automation-sidebar.vue?vue&type=template&id=4dd2ff0c&scoped=true"
import script from "./automation-sidebar.vue?vue&type=script&lang=js"
export * from "./automation-sidebar.vue?vue&type=script&lang=js"
import style0 from "./automation-sidebar.vue?vue&type=style&index=0&id=4dd2ff0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd2ff0c",
  null
  
)

export default component.exports